import { Result } from 'antd';
import React from 'react';
import { useRouteError } from 'react-router';

export const ErrorPage: React.FunctionComponent = () => {
  const error: any = useRouteError();
  console.log(error);

  // Handle structured API errors
  if (error instanceof Error && error.name === 'ApiError') {
    const apiError = error as any;
    const errorResponse = apiError.errorResponse;

    return (
      <Result
        status={apiError.statusCode === 404 ? 404 : 500}
        title={errorResponse?.message || apiError.message}
        subTitle={errorResponse?.type ? `Error Type: ${errorResponse.type}` : undefined}
        extra={[]}
      />
    );
  }

  // Handle standard route errors
  const status = error.status === 404 || error.status === 500 ? error.status : 500;
  const message = error.statusText;
  return <Result status={status} title={message} extra={[]} />;
};
